import { styled } from '@mui/system'
import { Box, Typography } from '@mui/material'

const DeleteModuleBodyWrapper= styled(Box)`
    display: flex;
    flex-direction: column;
    height: 19rem;
`
const DeleteModuleTextWrapper = styled(Box)`
    flex: 1;
    padding: 4.3rem 3.125rem 0;
`

const DeleteModuleParagraph = styled(Typography)`
    font-weight: 600;
    font-size: 1.1rem;
`

export {
    DeleteModuleBodyWrapper,
    DeleteModuleTextWrapper,
    DeleteModuleParagraph,
}
